var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"136","height":"29","viewBox":"0 0 136 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('ellipse',{attrs:{"cx":"67.5061","cy":"14.5","rx":"67.5","ry":"14.5","fill":"#C4C4C4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }